import { SetStateAction } from "react";
import { CustomComponentProps } from "utils/types/general.types";
import MyModal from "../core/MyModal";

export type ImageViewerProps = CustomComponentProps & {
    img: string;
    deleted: boolean;
    setDeleted: React.Dispatch<SetStateAction<boolean>>;
    open: boolean;
    setOpen: React.Dispatch<SetStateAction<boolean>>;
};

const ImageViewer = ({
    img,
    deleted,
    setDeleted,
    open,
    setOpen,
    className,
    style
}: ImageViewerProps) => {
    return (
        <MyModal
            open={open}
            setOpen={setOpen}
            className={`delete-image-modal ${className}`}
            style={style}
        >
            <div className="flex flex-col gap-3 justify-between items-center pt-5">
                <img
                    className="modal-image-preview"
                    src={img}
                    alt="Post Image"
                />
                <button
                    className={`${deleted ? "bg-momeento-50" : "bg-red-600"} text-white text-center rounded-full w-fit px-3 py-1`}
                    onClick={() => {
                        setDeleted(!deleted);
                        setOpen(false);
                    }}
                >
                    {deleted ? "Restore" : "Delete"}
                </button>
            </div>
        </MyModal>
    );
};

export default ImageViewer;
